import React from 'react';
import { isEqual, isEmpty } from 'lodash';
import {Button, Icon, message, Checkbox} from 'antd';
import {WeaTools , WeaLocaleProvider, WeaDialog, WeaInput, WeaInputSearch} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

// 元素设置
class EPortalBrowser extends React.Component {
    state = {visible: false, loading: false, value: this.props.value};

    constructor(props) {
        super(props);
        this.getButtons = this.getButtons.bind(this);
        this.onLoading = this.onLoading.bind(this);
        this.onOk = this.onOk.bind(this);
        this.onClear = this.onClear.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onShow = this.onShow.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({value: nextProps.value});
    }

    render() {
        const {type, value, disabled, multiCheck, getTooltipContainer = () => document.body, isShow, itemData=[], title} = this.props;
        const {visible, loading} = this.state;

        let displayComp = <div></div>;
        if (type == 'button') {
            displayComp = <div onClick={this.onShow}>{this.props.children}</div>;
        } else {
            displayComp = <WeaInputSearch style={{width: '100%'}} value={itemData[value] ? itemData[value].name: value} onSearchChange={this.onChange} onSearch={this.onShow}/>;
        }

        if (disabled) {
            displayComp = <WeaInput value={itemData[value] ? itemData[value].name: value} disabled={true}/>;
        }

        return (
            <div>
                {displayComp}
                <WeaDialog
                    visible={visible}
                    loading={loading}
                    title={title}
                    icon="icon-coms-portal"
                    iconBgcolor='#1a57a0'
                    style={{width: 800, height: 489}}
                    zIndex={1050}
                    buttons={this.getButtons()}
                    onCancel={this.onCancel}
                    layout={getTooltipContainer()}
                >
                    <PortalBrowserLib ref="ml" multiCheck={multiCheck} onLoading={this.onLoading} isShow={isShow} itemData={itemData} value={value}/>
                </WeaDialog>
            </div>
        );
    }

    getButtons() {
        let buttons = [];
        buttons.push(<Button type="primary" onClick={this.onOk}>{getLabel(826, '确定')}</Button>);
        // buttons.push(<Button type="primary" onClick={this.onClear}>{getLabel(311, '清除')}</Button>);
        buttons.push(<Button type="ghost" onClick={this.onCancel}>{getLabel(31129, '取消')}</Button>);
        return buttons;
    }

    onLoading(loading) {
        this.setState({loading});
    }

    onShow() {
        this.setState({visible: true});
        this.refs['ml'] && this.refs['ml'].setVisible({visible: true});
    }

    onOk() {
        const checkedFiles = this.refs['ml'].getCheckedFiles();
        if ((checkedFiles && checkedFiles.length) || this.state.value) {
            if(checkedFiles && checkedFiles.length){
                const id = checkedFiles.map((item) => {
                    return item.id;
                });
                const name = checkedFiles.map((item) => {
                    return item.name;
                });
                this.onChange(id.join(','), name.join(','), checkedFiles);
            }else {
                this.onChange(this.state.value,'', checkedFiles);
            }

            this.refs['ml'].setVisible(false);
            this.setState({visible: false});
        } else {
            message.warning(getLabel(84570, '请选择目标！'));
        }
    }

    onClear() {
        this.onChange('');
        this.refs['ml'].setVisible(false);
        this.setState({visible: false, value: ''});
    }

    onCancel() {
        this.refs['ml'].setVisible(false);
        this.setState({visible: false});
    }

    onChange(value) {
        this.props.onChange(value);
    }
}

export default EPortalBrowser;


class PortalBrowserLib extends React.Component {
    state = {visible: true, hasRight: false, checkedFiles: ""};

    constructor(props) {
        super(props);
        this.setVisible = this.setVisible.bind(this);
        this.onCheck = this.onCheck.bind(this);
    }

    onCheck(file) {
        const {multiCheck = false} = this.props;
        let {checkedFiles} = this.state;

        if (_.findIndex(checkedFiles, (item) => item.id == file.id) != -1) {
            _.remove(checkedFiles, (item) => item.id == file.id);
        } else {
            if (multiCheck) {
                checkedFiles.push(file);
            } else {
                checkedFiles = [file];
            }
        }

        this.setState({checkedFiles: checkedFiles});
    }

    render() {
        const {itemData, value} = this.props;
        const {visible} = this.state;

        const { checkedFiles} = this.state;

        let row = [], col = [];
        for (let i = 0, len = itemData.length; i < len; i++) {
            col.push(itemData[i]);
            if (i % 5 == 4 || i == len - 1) {
                row.push(col);
                col = [];
            }
        }

        if(visible) {
            return(
                <div className="portal-esetting-browser">
                    <div className="portal-esetting-browser-middle">
                        {
                            row && row.length ? (
                                <div className="portal-esetting-browser-table">
                                    {
                                        row.map((row, index) => {
                                            return (
                                                <ul key={index} className="portal-esetting-browser-tr">
                                                    {
                                                        row.map((col) => {
                                                            let checked = _.findIndex(checkedFiles, (item) => item.id == col.id) != -1;
                                                            if(isEmpty(checkedFiles)) {
                                                                checked = col.id == value;
                                                            }
                                                            return (
                                                                <li key={col.id} className="portal-esetting-browser-td">
                                                                    <div className="portal-esetting-browser-item" style={checked ? {border: '1px solid #408de2'} : {}} >
                                                                        <div className="portal-esetting-browser-chk" onClick={() => this.onCheck(col)}><Checkbox checked={checked}/>&nbsp;&nbsp;{col.name}</div>
                                                                        <div className="portal-esetting-browser-preview">
                                                                            <img className="portal-esetting-browser-img" src={col.filepath} alt=""/>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            );
                                        })
                                    }
                                    <div style={{clear: 'both'}}></div>
                                </div>
                            ) : (
                                <div className="ant-table-placeholder">
                                    <i className="anticon anticon-frown"/>{getLabel(83553, '暂无数据')}
                                </div>
                            )
                        }
                    </div>
                </div>
            )
        }else {
            return "";
        }
    }

    setVisible(visible) {
        this.setState({visible: visible});
    }

    getCheckedFiles() {
        return this.state.checkedFiles;
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/base/EPortalBrowser.js